//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
  PRIMARY_BTN_GK,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
  MINIMAL_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect, useState } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import FooterBar from "../../components/FooterBar";
import Ideology from "../../components/Ideology";
import BusinessHub from "../../components/BusinessHub";
import TimeLine from "../../components/TimeLine";
import Carousel from "react-bootstrap/Carousel";
import { TiLeaf } from "react-icons/ti";
import ComplaintCall from "../../components/ComplaintCall";
import QuemSomos from "../../assets/images/quem-somos.jpg";
import EsgPag1 from "../../assets/files/esg-grupo-krause_Página_01.jpg";
import EsgPag2 from "../../assets/files/esg-grupo-krause_Página_02.jpg";
import EsgPag3 from "../../assets/files/esg-grupo-krause_Página_03.jpg";
import EsgPag4 from "../../assets/files/esg-grupo-krause_Página_04.jpg";
import EsgPag5 from "../../assets/files/esg-grupo-krause_Página_05.jpg";
import EsgPag6 from "../../assets/files/esg-grupo-krause_Página_06.jpg";
import EsgPag7 from "../../assets/files/esg-grupo-krause_Página_07.jpg";
import EsgPag8 from "../../assets/files/esg-grupo-krause_Página_08.jpg";
import EsgPag9 from "../../assets/files/esg-grupo-krause_Página_09.jpg";
import EsgPag10 from "../../assets/files/esg-grupo-krause_Página_10.jpg";
import EsgPag11 from "../../assets/files/esg-grupo-krause_Página_11.jpg";
import EsgPag12 from "../../assets/files/esg-grupo-krause_Página_12.jpg";
import EsgPag13 from "../../assets/files/esg-grupo-krause_Página_13.jpg";
import EsgPag14 from "../../assets/files/esg-grupo-krause_Página_14.jpg";
import EsgPag15 from "../../assets/files/esg-grupo-krause_Página_15.jpg";
import EsgPag16 from "../../assets/files/esg-grupo-krause_Página_16.jpg";
import EsgPag17 from "../../assets/files/esg-grupo-krause_Página_17.jpg";
import EsgPag18 from "../../assets/files/esg-grupo-krause_Página_18.jpg";
import "./GrupoKrause.css";

export default function GrupoKrause() {
  const [esgDocument, setEsgDocument] = useState([
    { id: 1, src: EsgPag1, alt: "Página 1 - ESG" },
    { id: 2, src: EsgPag2, alt: "Página 2 - ESG" },
    { id: 3, src: EsgPag3, alt: "Página 3 - ESG" },
    { id: 4, src: EsgPag4, alt: "Página 4 - ESG" },
    { id: 5, src: EsgPag5, alt: "Página 5 - ESG" },
    { id: 6, src: EsgPag6, alt: "Página 6 - ESG" },
    { id: 7, src: EsgPag7, alt: "Página 7 - ESG" },
    { id: 8, src: EsgPag8, alt: "Página 8 - ESG" },
    { id: 9, src: EsgPag9, alt: "Página 9 - ESG" },
    { id: 10, src: EsgPag10, alt: "Página 10 - ESG" },
    { id: 11, src: EsgPag11, alt: "Página 11 - ESG" },
    { id: 12, src: EsgPag12, alt: "Página 12 - ESG" },
    { id: 13, src: EsgPag13, alt: "Página 13 - ESG" },
    { id: 14, src: EsgPag14, alt: "Página 14 - ESG" },
    { id: 15, src: EsgPag15, alt: "Página 15 - ESG" },
    { id: 16, src: EsgPag16, alt: "Página 16 - ESG" },
    { id: 17, src: EsgPag17, alt: "Página 17 - ESG" },
    { id: 18, src: EsgPag18, alt: "Página 18 - ESG" },
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="GrupoKrause">
      <DynamicTitle
        pageTitle="Grupo Krause - Nossa História"
        pageMeta="Grupo Krause"
        pageContent="Somos uma empresa com mais de 100 anos de história e tradição."
      />
      <BannerSection
        white={WHITE}
        //fadeBG={FADE_BG_GK}
        //iconTitle={
        //  <img
        //    src={LogoKrause}
        //    alt="Logo Krause"
        //    style={{ color: WHITE }}
        //    className="banner-section-icon-gk"
        //  />
        //}
        bannerTitle={"O GRUPO KRAUSE"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Respeito, dignidade e humanidade para cuidar de quem é importante para você."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={QuemSomos}
        bannerBGmobile={QuemSomos}
      />
      <Container>
        <Row className="gk-first-line">
          <Col>
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Somos o Grupo Krause, uma empresa com mais de 100 anos de história
              e tradição. Surgimos em 1922, com a fundação da Funerária Krause.
              Hoje, somos formados por quatro marcas que, juntas, entregam um
              dos mais completos pacotes de serviços funerários de todo o Rio
              Grande do Sul.
            </p>
          </Col>
        </Row>
        <Row className="gk-second-line">
          <Col>
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Estamos presentes na vida de milhares de famílias no Vale do Sinos
              e região, oferecendo vantagens e proteção em vida, passando pelo
              apoio na perda de um ente querido e realização de despedidas
              dignas e memoráveis.
            </p>
          </Col>
        </Row>
        <Row className="gk-third-line">
          <Col>
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Falar no Grupo Krause é falar de confiança, tradição, solidez,
              credibilidade e respeito. É falar em uma marca autêntica, humana,
              com empresas e profissionais que traduzem, genuinamente, o
              objetivo de valorizar a vida.
            </p>
          </Col>
        </Row>
      </Container>
      <TimeLine
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        minimalTextSize={MINIMAL_TEXT_SIZE}
      />
      <Ideology
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_GK}
      />
      <BusinessHub
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
      />
      <Container>
        <Row>
          <Col className="esg-first-col">
            <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
              <TiLeaf style={{ color: ICON_COLOR_GK }} className="esg-icon" />
              RESPONSABILIDADE
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="esg-second-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              O Grupo Krause tem o compromisso de atuar de forma responsável
              para as futuras gerações, ao mesmo tempo alinhados às principais
              tendências do mercado.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="esg-third-col">
            <Carousel
              controls={true}
              interval={null}
              indicators={true}
              fade
              touch={true}
              pause={false}
              wrap={false}
              className="esg-document-carousel"
            >
              {esgDocument.map((pag) => (
                <Carousel.Item
                  key={pag.id}
                  className="esg-document-carousel-container"
                >
                  <img
                    src={pag.src}
                    alt={pag.alt}
                    className="esg-document-carousel-item"
                  />
                  <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                    {pag.id} de 18
                  </p>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>
      </Container>
      <ComplaintCall
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_GK}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
